export default __webpack_public_path__ + "static/media/painting21.88b900cd.jpg";